import React from 'react';
import {rowColors} from "./styling/participation";
import LeftPartBodyTable from "./LeftPartBodyTable";
import InputItemParticipation from "../InputItemParticipation";

const participationEntry = (user, projectId) => {
    const isEntry = user.participation[projectId];
    return isEntry ? isEntry.status : '';
};


// wyswietla input, lupe i przyciski potwierdzen/zaprzeczen
const InputsTableParticipation = (
    {musicians, projectList, getStickyLeft, visibleColumns, instIndex, handleCopyEmail, dispatch, instrument, ChangeDBHandler}
) => {
    let renfortStartIndex = null;

    const sortedMusicians = [...musicians].sort((a, b) => {
        if (a.musician_category === b.musician_category) return 0;
        return a.musician_category === 'regular' ? -1 : 1;
    })

    const showDecisionButtons = (project, entry) => {
        return participationEntry(entry, project) === '1' && participationEntry(entry, project)
    }

    const showDetailForm = (projectID, musicianID, username, instrument) => {
        dispatch({
            type: "SET_DETAIL_FORM_PROPS",
            detailFormProps: {projectID, musicianID, username, instrument},
        })
        dispatch({type: "SET_SHOW_TABLE", showTable: false})
    }

    const isEven = (lp) => lp % 2 === 0;
    const isRenfort = (musician_category) => musician_category === 'renfort';

    const rowStyle = (lp, musician_category) => ({
        backgroundColor: isEven(lp)
        ? isRenfort(musician_category)
            ? rowColors.evenRenfort
            : rowColors.evenRegular
        : rowColors.odd
    });

    return(<>
        {sortedMusicians.map((entry, lp) => {
            if (renfortStartIndex === null && isRenfort(entry.musician_category)) {
                renfortStartIndex = lp;
            }
            return (
                <React.Fragment key={`user_${instIndex}_${lp}`}>
                    {lp === renfortStartIndex && (
                        <tr style={{ borderTop: '1px solid #bbb' }}>
                            <td colSpan={4 + projectList.length}></td>
                        </tr>
                    )}
                    <tr style={rowStyle(lp, entry.musician_category)}>
                        <LeftPartBodyTable
                            rowStyle={rowStyle}
                            entry={entry}
                            lp={lp}
                            getStickyLeft={getStickyLeft}
                            visibleColumns={visibleColumns}
                            handleCopyEmail={handleCopyEmail}
                        />
                        {/*right part body table*/}
                        {projectList.map(project => (
                            <td key={`p_${project.id}`} style={{ backgroundColor: rowStyle(lp, entry.musician_category).backgroundColor, verticalAlign: 'middle' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '4px' }}>
                                    <button
                                        style={{
                                            backgroundColor: null === `details-${project.id}-${entry.user_id}` ? '#003366' : '#d0e6ff',
                                            color: null === `details-${project.id}-${entry.user_id}` ? '#d0e6ff' : '#003366',
                                            //backgroundColor: 'rgba(0,0,0,0)',
                                            border: 'none',
                                            fontSize: '12px',
                                            fontWeight: 'bold'
                                        }}
                                        onClick={() =>showDetailForm(project.id, entry.user_id, entry.username, instrument)}
                                    >
                                        &#128269;
                                    </button>

                                    <InputItemParticipation
                                        entry={entry}
                                        projectID={project.id}
                                        instrument={instrument}
                                        ChangeDBHandler={ChangeDBHandler}
                                    />

                                    {showDecisionButtons(project.id, entry) &&
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
                                            <button
                                                onClick={() => {ChangeDBHandler(participationEntry(entry, project.id)+"+", project.id, entry.user_id, instrument, "accept")}}
                                                style={{
                                                    backgroundColor: null === `yes-${project.id}-${entry.user_id}` ? '#155724' : '#d4edda',
                                                    color: null === `yes-${project.id}-${entry.user_id}` ? '#d4edda' : '#155724',
                                                    border: 'none',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    margin: '0px'
                                                }}
                                            >
                                                ✓
                                            </button>

                                            <button
                                                onClick={() => {ChangeDBHandler(participationEntry(entry, project.id)+"-", project.id, entry.user_id, instrument, "decline")}}
                                                style={{
                                                    backgroundColor: null === `no-${project.id}-${entry.user_id}` ? '#721c24' : '#f8d7da',
                                                    color: null === `no-${project.id}-${entry.user_id}` ? '#f8d7da' : '#721c24',
                                                    border: 'none',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    margin: '0px'
                                                }}
                                            >
                                                ✖
                                            </button>
                                        </div>
                                    }
                                </div>
                            </td>
                        ))}
                    </tr>
                </React.Fragment>
            );
        })}
    </>)
}

export default InputsTableParticipation;

